import { FormType, IForm, IFormView } from 'shared/Form/types';

export const fields: IForm = {
  name: {
    type: FormType.TEXT,
    value: '',
    required: true,
    extraKey: 'name',
    label: 'Название',
  },
  title: {
    type: FormType.TEXT,
    value: '',
    required: true,
    extraKey: 'title',
    label: 'Заголовок',
  },
};

export const view: IFormView = [
  {
    block: [['name'], ['title']],
  },
];
